import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IClassTemplateBulkUpdateTypesValues } from 'types/IClassTemplateBulkUpdateTypes';
import { IEditClasses } from 'types/IEditClasses';

const initialState: IEditClasses = {
  academyProjectDetailsModalState: false,
  bulkUpdateSyncConfirmModalState: false,
  bulkUpdateSyncType: null,
};

export const editClasses = createSlice({
  name: 'editClasses',
  initialState,
  reducers: {
    setAcademyProjectDetailsModalState: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.academyProjectDetailsModalState = action.payload;
    },
    setBulkUpdateSyncConfirmModalState: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.bulkUpdateSyncConfirmModalState = action.payload;
    },
    setBulkUpdateSyncType: (
      state,
      action: PayloadAction<IClassTemplateBulkUpdateTypesValues | null>
    ) => {
      state.bulkUpdateSyncType = action.payload;
    },
  },
});

export const {
  setAcademyProjectDetailsModalState,
  setBulkUpdateSyncConfirmModalState,
  setBulkUpdateSyncType,
} = editClasses.actions;
export default editClasses.reducer;
